import type { MeasurementSchema } from './types';
export { createVALUE, roundValue, DEFAULT_FORMAT } from './shared/values';

/**
 * Per-form measurement schemas, keyed by `scoringCode`.
 *
 * The registry is intentionally empty — the multi-annotation engine is
 * form- and instrument-agnostic and ships with no baked-in schemas. A form
 * opts in by registering its own schema here:
 *
 *   import { myFormSchema } from './my-form.schema';
 *   export const schemaRegistry: Record<string, MeasurementSchema> = {
 *     [myFormSchema.formCode]: myFormSchema,
 *   };
 *
 * See `docs/how-to-add-multi-annotations-to-a-form.md` (Part A) for the contract.
 */
export const schemaRegistry: Record<string, MeasurementSchema> = {};

export const getSchema = (formCode: string): MeasurementSchema | undefined =>
  schemaRegistry[formCode];
